/**
 * Formatea una fecha ISO a dd-mm-aaaa
 * @param {string | Date} isoDate
 * @returns {string}
 */
export const formatDateDDMMYYYY = (isoDate) => {
  if (!isoDate) return '';

  const date = new Date(isoDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const formatDateYYYYMMDD = (isoDate) => {
  if (!isoDate) return '';

  const date = new Date(isoDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

/**
 * Formatea una fecha ISO a HH:MM:SS (24h)
 * @param {string | Date} isoDate
 * @returns {string}
 */
export const formatTime24h = (isoDate) => {
  if (!isoDate) return '';

  const date = new Date(isoDate);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};